import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../components/Layout'
import Connection from '../views/Connection'
import ResetPassword from '../components/ResetPassword'
import FreeRecord from '../views/FreeRecord'
import FreeGeneration from '../views/FreeGeneration'
import NavbarLayout from '../components/NavbarLayout'
import ThemeList from '../components/ThemeList'
import PersonList from '../components/PersonList'
import RealList from '../components/RealList'
import RealForm from '../components/RealForm'
import PersonForm from '../components/PersonForm'
import PersonDetail from '../components/PersonDetail'
import TextForm from '../components/TextForm'
import Review from '../components/Review'
import FirstVisit from '../components/FirstVisit'
import UserPersonList from '../components/UserPersonList'
import UserRecord from '../components/UserRecord'
import store from 'store'
import axios from 'axios'

Vue.use(Router)

const router = new Router({
    mode: 'hash',
    routes: [
    {
        path: '/',
        component: Layout,
        children: [
            {
                path: '',
                name: 'Connection',
                component: Connection
            },
            {
                path: 'access/:token',
                name: 'CheckAccess',
                beforeEnter: (to, from, next) =>    {
                    store.dispatch("getUserFromToken", {
                        token: to.params.token,
                        callbacks: {
                            success: (data) => {
                                store.commit("CURRENT_USER_UPDATED", data);
                                if (data.enabled)  {
                                    next('/');
                                }
                                else    {
                                    next({name:"FirstVisit", params: {userId: data.id}});
                                }
                            },
                            fail: () => {
                                next("/");
                            },
                            error: () => {
                                next("/");
                            }
                        }
                    });
                }
            },
            {
                path: 'reset-password/:resetId',
                name: 'ResetPassword',
                component: ResetPassword
            },
            {
                path: 'first-visit/:userId',
                name: 'FirstVisit',
                component: FirstVisit
            },
            {
                path: 'free-record',
                component: NavbarLayout,
                children: [
                    {
                        path: '',
                        name: 'FreeRecord',
                        component: FreeRecord
                    }
                ]
            },
            {
                path: 'free-generation',
                component: NavbarLayout,
                children: [
                    {
                        path: '',
                        name: 'FreeGeneration',
                        component: FreeGeneration,
                        beforeEnter(to, from, next) {
                            store.dispatch('getVoicePresets', {
                                success: () => {
                                    next();
                                }
                            });
                        }
                    }
                ]
            },
            {
                path: 'admin',
                component: NavbarLayout,
                children: [
                    {
                        path: '',
                        name: 'ThemeList',
                        component: ThemeList,
                        beforeEnter: (to, from, next) =>    {
                            store.dispatch("getThemeList", {callbacks: {
                                success: (data) => {
                                    store.commit("THEME_LIST_UPDATED", data);
                                    next();
                                },
                                fail: () => {
                                    next("/");
                                },
                                error: () => {
                                    next("/");
                                }
                            }});
                        }
                    },
                    {
                        path: 'reals/:themeId',
                        name: 'RealList',
                        component: RealList,
                        beforeEnter: (to, from, next) =>    {
                            store.dispatch("getTheme", {
                                themeId: to.params.themeId,
                                callbacks: {
                                    success: (data) => {
                                        store.commit("CURRENT_THEME_UPDATED", data);
                                        next();
                                    },
                                    fail: () => {
                                        next("/");
                                    },
                                    error: () => {
                                        next("/");
                                    }
                                }
                            });
                        }
                    },
                    {
                        path: 'theme/:themeId',
                        name: 'PersonList',
                        component: PersonList,
                        beforeEnter: (to, from, next) =>    {
                            store.dispatch('getVoicePresets');
                            store.dispatch("getTheme", {
                                themeId: to.params.themeId,
                                callbacks: {
                                    success: (data) => {
                                        store.commit("CURRENT_THEME_UPDATED", data);
                                        next();
                                    },
                                    fail: () => {
                                        next("/");
                                    },
                                    error: () => {
                                        next("/");
                                    }
                                }
                            });
                        }
                    },
                    {
                        path: 'theme/:themeId/new-person',
                        name: 'PersonCreate',
                        component: PersonForm,
                        meta: {mode: 'create'},
                        beforeEnter: (to, from, next) =>    {
                            store.commit("CURRENT_PERSON_UPDATED", {
                                data: {
                                    name: "",
                                    gender: "MALE",
                                    description: ""
                                }
                            });
                            next();
                        }
                    },
                    {
                        path: 'reals/:themeId/link',
                        name: 'RealLink',
                        component: RealForm,
                        meta: {mode: 'create'},
                        beforeEnter: (to, from, next) =>    {
                            store.commit("CURRENT_PERSON_UPDATED", {
                                data: {
                                    name: "",
                                    gender: "MALE",
                                    description: ""
                                }
                            });
                            next();
                        }
                    },
                    {
                        path: 'theme/:themeId/person/:personId/edit',
                        name: 'PersonEdit',
                        component: PersonForm,
                        meta: {mode: 'edit'},
                        beforeEnter: (to, from, next) =>    {
                            store.dispatch("getPerson", {
                                personId: to.params.personId,
                                callbacks: {
                                    success: (data) => {
                                        store.commit("CURRENT_PERSON_UPDATED", { data: data });
                                        next();
                                    },
                                    fail: () => {
                                        next("/");
                                    },
                                    error: () => {
                                        next("/");
                                    }
                                }
                            });
                        }
                    },
                    {
                        path: 'theme/:themeId/person/:personId/detail',
                        name: 'PersonDetail',
                        component: PersonDetail,
                        beforeEnter: (to, from, next) =>    {
                            store.dispatch('getVoicePresets');
                            store.dispatch("getPersonDetail", {
                                personId: to.params.personId,
                                callbacks: {
                                    success: (data) => {
                                        store.commit("CURRENT_PERSON_UPDATED", { data: data });
                                        next();
                                    },
                                    fail: () => {
                                        next("/");
                                    },
                                    error: () => {
                                        next("/");
                                    }
                                }
                            });
                        }
                    },
                    {
                        path: 'theme/:themeId/person/:personId/review',
                        name: 'PersonReview',
                        component: Review,
                        beforeEnter: (to, from, next) =>    {
                            store.dispatch("getPersonDetail", {
                                personId: to.params.personId,
                                callbacks: {
                                    success: (data) => {
                                        store.commit("CURRENT_PERSON_UPDATED", { data: data });
                                        next();
                                    },
                                    fail: () => {
                                        next("/");
                                    },
                                    error: () => {
                                        next("/");
                                    }
                                }
                            });
                        }
                    },
                    {
                        path: 'theme/:themeId/person/:personId/text/:textId/edit',
                        name: 'TextEdit',
                        component: TextForm,
                        meta: {mode: 'edit'},
                        beforeEnter: (to, from, next) =>    {
                            store.dispatch("getText", {
                                textId: to.params.textId,
                                callbacks: {
                                    success: (data) => {
                                        store.commit("CURRENT_TEXT_UPDATED", { data: data });
                                        next();
                                    },
                                    fail: () => {
                                        next("/");
                                    },
                                    error: () => {
                                        next("/");
                                    }
                                }
                            });
                        }
                    }
                ]
            },
            {
                path: 'user',
                component: NavbarLayout,
                children: [
                    {
                        path: ':userId/person-list/',
                        name: 'UserPersonList',
                        component: UserPersonList,
                        beforeEnter: (to, from, next) =>    {
                            store.dispatch("getUser", {
                                userId: to.params.userId,
                                callbacks: {
                                    success: (data) => {
                                        store.commit("CURRENT_USER_UPDATED", data);
                                        next();
                                    },
                                    fail: () => {
                                        next("/");
                                    },
                                    error: () => {
                                        next("/");
                                    }
                                }
                            });
                        }
                    },
                    {
                        path: ':userId/person/:personId',
                        name: 'UserRecord',
                        component: UserRecord,
                        beforeEnter: (to, from, next) =>    {
                            store.dispatch("getPersonDetail", {
                                personId: to.params.personId,
                                callbacks: {
                                    success: (data) => {
                                        store.commit("CURRENT_USER_PERSON_UPDATED", data);
                                        next();
                                    },
                                    fail: () => {
                                        next("/");
                                    },
                                    error: () => {
                                        next("/");
                                    }
                                }
                            });
                        }
                    }
                ]
            }
        ]
    }
]});

export default router;
